export default "__VITE_ASSET__01NTpuRE__"